import {
  ChangeDetectionStrategy,
  Component,
  model,
  ModelSignal,
  inject,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { uiKitScope } from '../../constants/ui-constant';

import { ButtonComponent } from '../../misc';
import { provideUiKitScope } from '../../providers';

@Component({
  selector: 'ui-confirm-modal',
  imports: [ButtonComponent, TranslocoDirective],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
})
export class ConfirmModalComponent {
  protected activeModal = inject(NgbActiveModal);

  protected readonly uiKitScope = uiKitScope;

  title: ModelSignal<string> = model('');
  description: ModelSignal<string> = model('');
  action: ModelSignal<string> = model('delete');

  confirm() {
    this.activeModal.close(true);
  }
}
